import { render } from "./PageBillboard.vue?vue&type=template&id=7ee49fa2&scoped=true&ts=true"
import script from "./PageBillboard.vue?vue&type=script&lang=ts"
export * from "./PageBillboard.vue?vue&type=script&lang=ts"

import "./PageBillboard.vue?vue&type=style&index=0&id=7ee49fa2&scoped=true&lang=css"

import exportComponent from "D:\\project\\CDM_QR-Access-Control-System-3\\DoorWebApp_Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ee49fa2"]])

export default __exports__